import { useQuery } from "@apollo/client";
import { CenterResult } from "__legacy/components/CenterResult";
import { CenterSpinner } from "__legacy/components/CenterSpinner";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import { UserQuery as UserQueryType, UserQueryVariables } from "./__generated__/UserQuery";

const UserQuery = loader("./UserQuery.gql");

type UserQueryProviderType = (props: {
  children: (data: UserQueryType) => ReactNode;
  variables: UserQueryVariables;
}) => ReactElement;

export const UserQueryProvider: UserQueryProviderType = (props) => {
  const { children, variables } = props;

  const { error, loading, data } = useQuery<UserQueryType, UserQueryVariables>(UserQuery, {
    variables,
    fetchPolicy: "cache-and-network",
  });

  if (loading) return <CenterSpinner size="large" />;
  if (error || !data)
    return <CenterResult status="404" title="404" subTitle="Sorry, the page you visited does not exist." />;

  return <Fragment>{children(data)}</Fragment>;
};
